import { useConfig } from "@jti/app-context/useConfig";
import { useDispatch, useSelector } from "@jti/store/reduxHooks";
import { selectProductsInCart } from "@jti/store/selectors/selectProductsInCart";
import { selectTradeInOrderAttributes } from "@jti/store/selectors/selectTradeInOrderAttributes";
import type { CartSliceState } from "@jti/store/slices/cartSlice";
import { setTradeInErrorMessage } from "@jti/store/slices/cartSlice";

export const useCartTradeInError = () => {
  const dispatch = useDispatch();
  const { tradeInErrorMessage } = useSelector((store) => store.cart);
  const { showPricesWithTaxExcluded = false } = useConfig();

  const selectedTradeInOrderAttributes = useSelector(selectTradeInOrderAttributes);
  const { traded_in_model } = selectedTradeInOrderAttributes || {};

  const productsInCart = useSelector((state) => selectProductsInCart(state, false, showPricesWithTaxExcluded));
  const isTradeInItemInCart = productsInCart.some((item) => !!item.tradeIn);

  const setError = (errorMessage: CartSliceState["tradeInErrorMessage"]) => {
    dispatch(setTradeInErrorMessage(errorMessage));
  };

  return {
    isTradeInItemInCart,
    isTradeInItemSelected: !!traded_in_model,
    errorMessage: tradeInErrorMessage,
    setError,
  };
};
